import { render, staticRenderFns } from "./examesextracao.vue?vue&type=template&id=0f090239"
import script from "./examesextracao.vue?vue&type=script&lang=js"
export * from "./examesextracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports